export * from './clinic.interface';
export * from './clinic-counters.interface';
export * from './clinic.redux';
export * from './clinical-objective.interface';
export * from './clinical-statistic.interface';
